import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import env from './env';
import rebase from './rebase';
import App from './App';

import ListsView from './ListsView';
import ItemsView from './ItemsView';
import LoginView from './LoginView';
import DragDrop from './misc/dragDrop';
// import './ElementsComponents';

import 'normalize.css';
import './index.css';

const routes = (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={ListsView} onEnter={checkAuth} />
      <Route path="items/:list" component={ItemsView} onEnter={checkAuth} />
      <Route path="login" component={LoginView} />
      <Route path="dragdrop" component={DragDrop} />
    </Route>
  </Router>
);

ReactDOM.render(routes, document.getElementById('root'));

if (env.development) {
  document.title = 'ReShop Dev';
}

function checkAuth(nextState, replace, next) {
  const unsubscribe = rebase.onAuth(user => {
    console.log('index.onAuth', user);
    if (!user) {
      replace('/login');
    }

    unsubscribe();
    next();
  });
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/